import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import { Spinner } from 'components';
import { uploadImages } from 'redux/modules/adBuilder';

function ImageUploadSection(props) {
  var onChange = props.onChange,
      logoUrl = props.logoUrl,
      uploadingFile = props.uploadingFile,
      upload = props.uploadImages,
      removeImage = props.removeImage,
      organization = props.organization;

  var handleDrop = function handleDrop(files) {
    if (files && files.length > 0) {
      upload(files, organization.id).then(function (result) {
        var newItems = _toConsumableArray(result.data);

        if (onChange) {
          onChange(newItems.map(function (item) {
            return item.fullyQualifiedUrl;
          }));
        }
      })["catch"](function (err) {
        console.error(err);
      });
    }
  };

  var dropzone = /*#__PURE__*/React.createElement(Dropzone, {
    multiple: false,
    onDrop: handleDrop,
    accept: 'image/*',
    style: {
      width: 235,
      height: 50,
      borderColor: '#8b8b8b',
      borderRadius: 4,
      border: '1px dashed #8b8b8b'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 8,
      display: 'flex',
      alignItems: 'center',
      justifyItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#8b8b8b',
      fontSize: 13,
      textAlign: 'center'
    }
  }, "Drop image here or click to upload.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 11,
      marginTop: 6,
      display: 'inline-block'
    }
  }, "*Suggested size: 235 x 50"))));
  var dropzoneRender = dropzone;

  if (uploadingFile) {
    dropzoneRender = /*#__PURE__*/React.createElement(Spinner, {
      center: true
    });
  }

  return /*#__PURE__*/React.createElement("div", {
    style: {
      minHeight: props.height,
      position: 'relative'
    }
  }, dropzoneRender);
}

function mapStateToProps(state) {
  var orgId = state.organization.current.id;
  return {
    uploadingFile: state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)].uploadingFile : false,
    organization: state.organization.current
  };
}

var actionCreators = {
  uploadImages: uploadImages
};
ImageUploadSection.defaultProps = {
  height: 120
};
export default connect(mapStateToProps, actionCreators)(ImageUploadSection);